import React from 'react';

const PrevButtonSVG = () => (
  <svg width="38" height="73" viewBox="0 0 38 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="38" height="73" rx="19" transform="matrix(-1 0 0 1 38 0)" fill="white" />
    <path
      d="M21 41.5L16 36.5L21 31.5"
      stroke="#666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PrevButtonSVG;



// WEBPACK FOOTER //
// ./src/components/icons/PrevButtonSVG.js